const BASE64_PATTERN = /^[A-Za-z0-9+/]+={0,2}$/;
const NUMERIC_ENTITY = /&#(\d+);/g;
const MIN_ENCODED_CODE_POINT = 128;
const MAX_CODE_POINT = 0x10FFFF;

const isBase64 = (value) => (
  typeof value === 'string' && !!value && value.length % 4 === 0 && BASE64_PATTERN.test(value)
);

// Only the entities the encoder wrote (code points ≥ 128): an author's own `&#60;` stays escaped.
const fromAsciiEntities = (html) => html.replace(NUMERIC_ENTITY, (match, code) => {
  const codePoint = Number(code);
  return codePoint >= MIN_ENCODED_CODE_POINT && codePoint <= MAX_CODE_POINT
    ? String.fromCodePoint(codePoint)
    : match;
});

/**
 * Rich-text content saved by the manager is base64-encoded (non-ASCII
 * characters first written as numeric HTML entities). Decodes it back to
 * HTML; anything that isn't base64 — content saved before the encoding, plain
 * labels — is returned untouched.
 */
export const decodeHtmlContent = (value) => {
  let decoded = value;
  if (isBase64(value)) {
    try {
      const bytes = Uint8Array.from(atob(value), (char) => char.charCodeAt(0));
      decoded = fromAsciiEntities(new TextDecoder('utf-8', { fatal: true }).decode(bytes));
    } catch {
      decoded = value;
    }
  }
  return decoded;
};

export default decodeHtmlContent;
